import {
  classnames,
  createBlock,
  mergeBlock,
  t,
} from "@easy-email-pro-core/utils";

import {
  ElementCategory,
  ElementType,
  SLATE_CODE_BLOCK_CLASSNAME,
} from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  DangerousCodeElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock, ContentLeaf } from "@easy-email-pro-core/components";
import { cloneDeep } from "lodash";
import he from "he";

const defaultData: ElementDefinition<DangerousCodeElement>["defaultData"] = {
  attributes: {
    align: "left",
    color: "#000000",
    "font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "line-height": "1",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    "letter-spacing": "0px",
  },
  data: {
    code: "",
  },
};

export const Code = createBlock<DangerousCodeElement>({
  get name() {
    return t("Code");
  },
  void: true,
  defaultData,
  type: ElementType.DANGEROUS_CODE,
  create: (payload) => {
    const defaultData: DangerousCodeElement = {
      type: ElementType.DANGEROUS_CODE,
      data: {
        code: "",
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.DANGEROUS_CODE,
  render(params) {
    const node = cloneDeep(params.node);
    const isProduction = params.mode === "production";
    if (!isProduction) {
      node.attributes["css-class"] = classnames(
        node.attributes["css-class"],
        SLATE_CODE_BLOCK_CLASSNAME
      );
    }

    const code = params.node.data.code;
    return (
      <BasicBlock
        params={{
          ...params,
          node: node,
        }}
        tag="mj-text"
        children={
          <ContentLeaf
            node={{
              text: isProduction ? code : he.encode(code),
            }}
          />
        }
      />
    );
  },
});
